import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import handleTeacherError from "@/util/handle_teacher_error";
import apiRequest from '@/util/api-request';
import { IAcademicYearClass } from "@/consts/interfaces";


export const useLearningProgressStore = defineStore('teacherLearningProgressStore', {
  // actions
  actions: {
    // FIXME このAPI は learning_progress のものではなくなったので引越しする（NFR-4137）
    async fetchYearClass(): Promise<IAcademicYearClass> {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/school/year_class/",
          headers: {
            "Content-Type": "application/json",
          }
        };
        const academicYearsClassrooms = await apiRequest(config);
        return {
          "defaultAcademicSessionId": academicYearsClassrooms.data.default_academic_session_id,
          "academicSessionIds": academicYearsClassrooms.data.academic_session_ids,
          "academicYears": academicYearsClassrooms.data.academic_years,
          "classrooms": academicYearsClassrooms.data.classrooms,
        }
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchLearningProgressWorksConditions({classroom_uuid, subject_id}) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/learning_progress/conditions/works/",
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            classroom_uuid: classroom_uuid,
            subject_id: subject_id,
          },
        };
        const response = await apiRequest(config);
        return response.data.works
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchLearningProgressChapterSectionQuestionSetList(params) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/learning_progress/chapter_section_question_set_list/",
          headers: {
            "Content-Type": "application/json",
          },
          params: params
        };
        const chapterSectionQuestionSetList = await apiRequest(config);
        return chapterSectionQuestionSetList.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchLearningProgressQuestionCorrectAnswerList(params) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/learning_progress/question_correct_answer_list/",
          headers: {
            "Content-Type": "application/json",
          },
          params: params
        };
        const questionCorrectAnswerList = await apiRequest(config);
        return questionCorrectAnswerList.data
      } catch (e) {
        handleTeacherError(e)
      }
    }
  }
})
